import {Component, OnInit, ViewChild} from '@angular/core';
import Swal from "sweetalert2";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import * as XLSX from "xlsx";
import { IProduct, Product } from '../../../../../../models/product.model';
import { ProductService } from '../../../../../../services/product.service';
import { EncryptionService } from '../../../../../../services/EncryptionService';
import { SharedFonctionsService } from '../../../../../../services/shared-fonctions.service';
import { environment } from '../../../../../../environments/environment';
import { Observable, of } from 'rxjs';
import { CountryService } from '../../../../../../services/country.service';
import { IShop } from '../../../../../../models/shop.model';
import { ICity } from '../../../../../../models/city.model';
import { ICountry } from '../../../../../../models/country.model';
import { JobOffer } from '../../../../../../models/jobOffer.model';
import { CityService } from '../../../../../../services/city.service';
import { ISubProductCharacteristic } from '../../../../../../models/subProductCharacteristic.model';
import { ICharacteristics } from '../../../../../../models/characteristics.model';
import { SubProduct } from '../../../../../../models/subProduct.model';
import { map } from 'rxjs/operators';
import { CharacteristicsService } from '../../../../../../services/characteristics.service';
import { IPostSubProducts, PostSubProducts } from '../../../../../../models/post-sub-products';
import { Post } from '../../../../../../models/post.model';
import { VariantService } from '../../../../../../services/variant.service';
import { PostService } from '../../../../../../services/post.service';
import { nameBoutiqueValidator } from '../../../../validators/validator';
import { requiredValidator } from '../../../../validators/validator';
import { allNumberValidator } from '../../../../validators/validator';
import { emailValidator } from '../../../../validators/validator';
import { AuthService } from '../../../../../../services/auth.service';

@Component({
  selector: 'app-kahpoo-employe-offer',
  templateUrl: './kahpoo-employe-offer.component.html',
  styleUrls: ['./kahpoo-employe-offer.component.scss']
})
export class KahpooEmployeOfferComponent implements OnInit {
  @ViewChild('closebutton') closebutton;
  url_photo:any;
  products: IProduct[] =[];
  productsTmp: IProduct[] =[];
  filtred:IProduct[]=[];
  filter = false;
  allProduct:IProduct[]=[];
  pageNumber: number = 1;
  pageSize: number = 10;
  totalItems :any;
  productSubTypesSaved:SubProduct[] = [];
  search: any;
  cities:ICity[]=[];
  countries:ICountry[]=[];
  country:ICountry[]=[];
  userOldPhoneNumber : any;
  isVerify = false;
  test=false;
  msg00: string;
  url00: any;
  test00=false;
  photoProduit: string = "";
  validProductPhoto:any;
  // @ts-ignore
  user: IUser = [];
  // @ts-ignore
  offer: IJobOffer = [];
  shop: IShop[] = [];
  sharedIdShop : any;
  sharedINameShop : String;
  indicatif?:string="";
  tel:any
  defaultSelect: any = 0;
  defaultSelectCity: any = 0;
  allJobCharacteristic: ICharacteristics[] =[];
  whenClickForChangeImage: boolean=false;
  // @ts-ignore
  public year: number;
  // @ts-ignore
  public month: number;
  // @ts-ignore
  public day: number;
  // @ts-ignore
  public maxDate: Date;
  // @ts-ignore
  public minDate: Date;
  updatedCountry : any;
  updatedcity : any;
  updatedcities:ICity[]=[];
  cityName:any = "";
  constructor(private router:Router,private productService: ProductService,private fb: FormBuilder,
              private variantService: VariantService, private encryptionService: EncryptionService,
              private sharedSevice: SharedFonctionsService, private countryService: CountryService,
              private cityService: CityService, private characteristicService : CharacteristicsService,
              private postService:PostService, private authService: AuthService) { }
  date;
  ngOnInit(): void {
    this.url_photo=environment.url_photo;
    this.loadCountry();
    this.loadJobInformation();
    this.loadProductEmployeJob();
    this.loadJobCharacteristic();
    this.year  = new Date().getFullYear();
    this.month = new Date().getMonth();
    this.day   = new Date().getDate();
    this.maxDate  = new Date(this.year -16, this.month, this.day);
    this.minDate = new Date(1911, 1, 1);
    this.date = new Date().toISOString().slice(0, 10);
  }
  jobOfferForm = this.fb.group({
    name: new FormControl('',{ validators: nameBoutiqueValidator('L\'intitulé du poste', 5, 80), updateOn: 'change'} ),
    companyPresentation: new FormControl('',[Validators.required, Validators.minLength(10), Validators.maxLength(5000)] ),
    offerDescription: new FormControl('',[Validators.required, Validators.minLength(10), Validators.maxLength(5000)]  ),
    requiredProfile:  new FormControl('',{ validators: nameBoutiqueValidator('Le profil recherché', 5, 80), updateOn: 'change'} ),
    typeOfContract:  new FormControl('',{ validators: nameBoutiqueValidator('Le type de contrat', 3, 80), updateOn: 'change'} ),
    residenceCountry: new FormControl('',{ validators: requiredValidator('Le pays'), updateOn: 'change'} ),
    residenceCity: new FormControl('',{ validators: requiredValidator('La ville'), updateOn: 'change'} ),
    phoneNumber: new FormControl('',{ validators: allNumberValidator('Le numéro de téléphone', 9, 14), updateOn: 'change'} ),
    contactEmail:  new FormControl('',{ validators: emailValidator('L\'adresse email'), updateOn: 'change'} ),
    offerDeadline: new FormControl('',{ validators: requiredValidator('La date limite'), updateOn: 'change'} ),
  });

  jobOfferFormEdit = this.fb.group({
    name: new FormControl('',{ validators: nameBoutiqueValidator('L\'intitulé du poste', 5, 80), updateOn: 'change'} ),
    companyPresentation: new FormControl('',[Validators.required, Validators.minLength(10), Validators.maxLength(5000)]  ),
    offerDescription: new FormControl('',[Validators.required, Validators.minLength(10), Validators.maxLength(5000)] ),
    requiredProfile:  new FormControl('',{ validators: nameBoutiqueValidator('Le profil recherché', 5, 80), updateOn: 'change'} ),
    typeOfContract:  new FormControl('',{ validators: nameBoutiqueValidator('Le type de contrat', 3, 80), updateOn: 'change'} ),
    residenceCountry: new FormControl('',[]),
    residenceCity: new FormControl('',[] ),
    phoneNumber: new FormControl('',{ validators: allNumberValidator('Le numéro de téléphone', 9, 14), updateOn: 'change'} ),
    contactEmail:  new FormControl('',{ validators: emailValidator('L\'adresse email'), updateOn: 'change'} ),
    offerDeadline: new FormControl('',{ validators: requiredValidator('La date limite'), updateOn: 'change'} ),
  });

  get getJobForm() { return this.jobOfferForm.controls; }
  get getJobFormEdit() { return this.jobOfferFormEdit.controls; }

  dateForm = this.fb.group({
    beginDate: new FormControl(''),
    endDate: new FormControl('')
  })

  loadJobCharacteristic = () => {
    this.characteristicService.getJobCharacteristic().subscribe((data :any)=>{
      //console.log("Liste des caractéristique");
      //console.log(data);
      this.allJobCharacteristic = data;
    })
  };

  loadProductEmployeJob = () => {
    this.allProduct= [];
    this.filtred = [];
    this.productService.loadKahpooOffer(this.pageNumber-1, this.pageSize).subscribe((data :any)=>{
      this.totalItems = data.totalElements;
      // this.product = listeProductRemoveRedondance;
      this.products = data.content;
      // this.productTmp = listeProductRemoveRedondance;
      this.productsTmp = data.content;
      //console.log("Liste des offres d'emploi");
      //console.log(this.products);

    })
  };

  loadJobInformation(){
    this.offer = new JobOffer();

    this.authService.getUSerBySessionId().subscribe((rest: any) => {
      this.user = rest;
      //console.log("rest");
      //console.log(this.user);
      this.indicatif = this.user.indicatif;
      this.userOldPhoneNumber = this.user.phoneNumber;
    })
  }

  raiseTableSize(event: any) {
    this.pageSize = event.target.value;
    this.loadProductEmployeJob();
  }

  currentSection: string = 'mesProduits';
  toggleSection(section: string) {
    this.currentSection = section;
  }

  isRequiredCity = false;

  isSelectedCity(citySelected: any){
    if(citySelected){
      this.isRequiredCity = false;
      this.cities.forEach(elementAt=>{
        if(elementAt.id==citySelected){
          this.cityName = elementAt.name;
        }
      })
    }
  }

  mettreatrue  = false;
  testRequiredValue(){
    this.mettreatrue = true;
  }


  numberOnly(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  searchFilter($event: KeyboardEvent) {
    this.search = this.search.toString().toLowerCase();
    this.products = this.sortProductsByDate(
      this.productsTmp.filter(
        value => value.name?.toLowerCase().includes(this.search) || value.category?.name?.toLowerCase().includes(this.search) || value.productID?.toLowerCase().includes(this.search) || value.shop?.name?.toLowerCase().includes(this.search) || value.shop?.shopID?.toLowerCase().includes(this.search)
        || value.name?.toLowerCase().includes(this.search) || value.category?.name?.toLowerCase().includes(this.search) || value.productID?.toLowerCase().includes(this.search) || value.shop?.name?.toLowerCase().includes(this.search) || value.shop?.shopID?.toLowerCase().includes(this.search)
        || value.name?.includes(this.search) || value.category?.name?.includes(this.search) || value.productID?.includes(this.search) || value.shop?.name?.includes(this.search) || value.shop?.shopID?.includes(this.search) || value?.product_type?.name?.toLowerCase().includes(this.search)
    ));
  }

  sortProductsByDate(products: Product[]): Product[] {
    return products.sort((a, b) => {
      if (a.createdAt && b.createdAt) {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return dateB.getTime() - dateA.getTime();
      } else {
        return 0;
      }
    });
  }

  loadCity= () => {
    this.cityService.getAllCities().subscribe((data :any)=>{
      this.cities = data
    })
  };

  loadCountry= () => {
    let search = true;
    this.countryService.getCountrys().subscribe((data :any)=>{
      this.countries = data;
      //console.log("Liste des pays");
      //console.log(this.countries);
      if(search){
        this.countries.forEach(element=>{
          if(element.iso === this.user.residenceCountry){
            if(element?.id)
            this.cityService.getCitiesByCountry(element?.id).subscribe((data :any)=>{
              this.cities = data;
            });
            search = false;
          }
        });
      }

    })
  };

  boutiquePage()
  {
    this.router.navigate(["/boutique"]).then(() => {
      // window.location.reload();
    });
  }

  onFormSubmit(): void{
    this.productSubTypesSaved = [];
    // Vérifie si le formulaire est valide avant de le soumettre
    if (this.jobOfferForm.invalid) {
      // Marque tous les champs comme touchés pour afficher les messages d'erreur
      //console.log("Marque tous les champs comme touchés pour afficher les messages d'erreur")
      //console.log(this.jobOfferForm.invalid);
      //console.log(this.msg00);
      this.jobOfferForm.markAllAsTouched();
      return;
    }
    //const newJobOffer = new JobOffer();
    let newJobOffer = new Product();
    const jobOfferFormValue = this.jobOfferForm.value;
    //console.log("Ajout d'une nouvelle offre d'emploi");
    //console.log(jobOfferFormValue);
    let subProduct = new SubProduct();
    newJobOffer.name = jobOfferFormValue.name;
    newJobOffer.productDeliveryZones = [];
    const subProductCharacteristics: ISubProductCharacteristic[] = this.allJobCharacteristic.map(characteristic => ({
      characteristic: characteristic,
      value: ''
    }));

    subProductCharacteristics.forEach(async  item => {
      // Vérifier si item et item.characteristic sont définis
      if(item && item.characteristic) {

          if (item.characteristic.name?.trim() === "type.of.contract") {
              item.value = jobOfferFormValue.typeOfContract;
          }
          if (item.characteristic.name?.trim() === "company.presentation") {
            item.value = jobOfferFormValue.companyPresentation;
          }
          if (item.characteristic.name?.trim() === "description.of.the.offer") {
            item.value = jobOfferFormValue.offerDescription;
          }
          if (item.characteristic.name?.trim() === "required.profile") {
            item.value = jobOfferFormValue.requiredProfile;
          }

          if (item.characteristic.name?.trim() === "contract.country") {
            item.value = this.countryIsoName;
            // this.getCountryISO(jobOfferFormValue.residenceCountry).subscribe(countryISO => {
            // });
          }
          if (item.characteristic.name?.trim() === "contract.city") {
            item.value = jobOfferFormValue.residenceCity;
          }
          if (item.characteristic?.name?.trim() === "code.country") {
            item.value = this.indicatif;
          }
          if (item.characteristic?.name?.trim() === "phone.number") {
            item.value = jobOfferFormValue.phoneNumber;
          }
          if (item.characteristic.name?.trim() === "email.contact") {
            item.value = jobOfferFormValue.contactEmail;
          }
          if (item.characteristic.name?.trim() === "offer.deadline") {
            item.value = jobOfferFormValue.offerDeadline;
          }
      }
    });

    subProduct.photo = this.photoProduit;
    subProduct.quantity = 10;
    subProduct.price = 10;
    subProduct.threshold = 10;
    subProduct.photoTampon = this.photoProduit;
    subProduct.subProductCharacteristics = subProductCharacteristics;
    this.productSubTypesSaved.push(subProduct);

    //console.log("new productSubTypesSaved", this.productSubTypesSaved)

    newJobOffer.subProducts = this.productSubTypesSaved;

    //console.log("new jbSave", newJobOffer)

    this.productService.saveKahpooOffer(newJobOffer).subscribe(
        (response) => {
            //console.log("Offre d'emploi enregistrée avec succès :", response);
            // Réinitialise le formulaire après l'enregistrement réussi

            //this.jobOfferForm.reset();
            this.showSuccessNotification();

        },
        (error) => {
           // console.error("Erreur lors de l'enregistrement de l'offre d'emploi :", error);
            // Gère les erreurs d'enregistrement, par exemple, afficher un message d'erreur à l'utilisateur
            this.showErrorNotification();
        }
    );

  }

  close() {
    this.closebutton.nativeElement.click();
  }

  showSuccessNotification(): void {
    this.close();
    this.loadProductEmployeJob();
    this.reloadComponent();
    Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Votre offre a été enregistré avec succès.',
        showConfirmButton: false,
        timer: 1500
    });
  }

  showErrorNotification(): void {
    Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Erreur lors de l\'enregistrement du produit.',
        text: 'Veuillez réessayer.',
        showConfirmButton: true
    });
  }

  countryIsoName:any = "";
  onChangeCountry(countryId: any) {
    if(countryId) {
      this.getCountryISO(countryId).subscribe(countryISO => {
        this.countryIsoName = countryISO;
      });
      this.cityService.getCitiesByCountry(countryId).subscribe((data :any)=>{
        this.cities = data;
      });
      this.jobOfferForm.get('residenceCity')?.reset();
    }
  }

  getIso(countryId: any){
    this.countries.forEach(element=>{
      if(element.id==countryId){
        this.countryService.getCountries().subscribe( data=>{
          data.forEach((el:any)=>{
            if(el.code== element.name){
              this.indicatif=el.iso;
            }
        });
      })
      }
    })
  }

  getCountryISO(countryId: any): Observable<string | null> {
    if (countryId) {
      return this.countryService.getidCountry(countryId).pipe(
        map((data: any) => {
          return data && data.iso ? data.iso : null;
        })
      );
    }
    return of(null);
  }

  updatedProduct:any;
  onEditProduct(p: any) {
    this.updatedProduct = p;
    //console.log("Produit à modifier ...");
    //console.log(this.updatedProduct);
    // Remplir le formulaire avec les données chargées
    this.photoProduit = this.url_photo + this.updatedProduct.subProducts[0].photo;
    //console.log("this.photoProduit..."+this.photoProduit);
    this.indicatif = this.getIndicatif(this.updatedProduct);
    this.jobOfferFormEdit.patchValue({
      name: this.updatedProduct.name,
      companyPresentation: this.entreprisePresentation(this.updatedProduct),
      requiredProfile: this.getProfilName(this.updatedProduct),
      offerDescription: this.offerDescription(this.updatedProduct),
      typeOfContract: this.getTypeContrat(this.updatedProduct),
      offerDeadline: this.getLimitDate(this.updatedProduct),
      residenceCountry: this.getPays(this.updatedProduct),
      residenceCity: this.getVille(this.updatedProduct),
      phoneNumber: this.getPhoneNumber(this.updatedProduct),
      contactEmail: this.getEmail(this.updatedProduct)
    });
    this.loadCountryByName(this.getPays(this.updatedProduct));
  }


  loadCountryByName= (countryName: any) => {
    this.countryService.getCountryByName(countryName).subscribe((data :any)=>{
      this.updatedCountry = data.id;
      this.countryIsoName = data.iso;
      // console.log("data...id"+data.id)
      // console.log("data...S"+data.name)
      // console.log("updatedCountry"+this.updatedCountry)
      this.cityService.getCitiesByCountry(data.id).subscribe((data :any)=>{
        this.cities = data;
        this.updatedcities = data;
        //console.log("City-_-_-_-_@@@@@@@@@@ ")
       // console.log(this.cities);
        this.updatedcities.forEach(elementAt=>{
          // console.log("-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_- ")
          // console.log(elementAt.name);
          // console.log(this.getVille(this.prod));
          // console.log(elementAt.name === this.getVille(this.prod));
          if(elementAt.name === this.getVille(this.updatedProduct)){
            this.updatedcity = elementAt.id;
            this.cityName = elementAt.name;
          }
        });
       // console.log("updatedCountry -_-_-_-_-_-"+this.updatedCountry)
        //console.log("updatedCCity -_-_-_-_-_-"+this.updatedcity)
        this.jobOfferFormEdit.get('residenceCountry')?.setValue(Number(this.updatedCountry));
        this.jobOfferFormEdit.get('residenceCity')?.setValue(Number(this.updatedcity));
      });

    });
  };

  onEditFormSubmit(): void{
    this.productSubTypesSaved = [];
    // Vérifie si le formulaire est valide avant de le soumettre
    if (this.jobOfferFormEdit.invalid) {
      // Marque tous les champs comme touchés pour afficher les messages d'erreur
      this.jobOfferFormEdit.markAllAsTouched();
      return;
    }
    //const newJobOffer = new JobOffer();
    const jobOfferFormValue = this.jobOfferFormEdit.value;
    //console.log("jobOfferForm valuee ..."+jobOfferFormValue);
    //console.log("jobOfferFormValue.typeOfContract "+jobOfferFormValue.typeOfContract);
    let subProduct = this.updatedProduct.subProducts[0];
    this.updatedProduct.name = jobOfferFormValue.name;
    this.updatedProduct.productDeliveryZones = [];
    const subProductCharacteristics: ISubProductCharacteristic[] = this.allJobCharacteristic.map(characteristic => ({
      characteristic: characteristic,
      value: ''
    }));

    subProductCharacteristics.forEach(async  item => {
      // Vérifier si item et item.characteristic sont définis
      if(item && item.characteristic) {

          if (item.characteristic.name?.trim() === "type.of.contract") {
              item.value = jobOfferFormValue.typeOfContract;
          }
          if (item.characteristic.name?.trim() === "company.presentation") {
            item.value = jobOfferFormValue.companyPresentation;
          }
          if (item.characteristic.name?.trim() === "description.of.the.offer") {
            item.value = jobOfferFormValue.offerDescription;
          }
          if (item.characteristic.name?.trim() === "required.profile") {
            item.value = jobOfferFormValue.requiredProfile;
          }

          if (item.characteristic.name?.trim() === "contract.country") {
            item.value = this.countryIsoName;
            // this.getCountryISO(jobOfferFormValue.residenceCountry).subscribe(countryISO => {
            //   item.value = countryISO || '';
            // });
          }
          if (item.characteristic.name?.trim() === "contract.city") {
            item.value = this.cityName;
            // this.getCityName(jobOfferFormValue.residenceCity).subscribe(cityName => {
            //   item.value = cityName || '';
            // });
          }
          if (item.characteristic?.name?.trim() === "code.country") {
            item.value = this.indicatif;
          }
          if (item.characteristic?.name?.trim() === "phone.number") {
            item.value = jobOfferFormValue.phoneNumber;
          }
          if (item.characteristic.name?.trim() === "email.contact") {
            item.value = jobOfferFormValue.contactEmail;
          }
          if (item.characteristic.name?.trim() === "offer.deadline") {
            item.value = jobOfferFormValue.offerDeadline;
          }
      }
    });

    this.whenClickForChangeImage == false ?  subProduct.photo=this.updatedProduct.subProducts[0].photo : subProduct.photo=this.photoProduit;
    // subProduct.photo = this.photoProduit;
    subProduct.quantity = 10;
    subProduct.price = 10;
    subProduct.threshold = 10;
    this.whenClickForChangeImage == false ?  subProduct.photoTampon=this.updatedProduct.subProducts[0].photo : subProduct.photoTampon=this.photoProduit;
    subProduct.subProductCharacteristics = subProductCharacteristics;
    this.productSubTypesSaved.push(subProduct);

    this.updatedProduct.subProducts = this.productSubTypesSaved;

   // console.log("New updated product", this.updatedProduct)

    this.productService.updateJobProduct_new(this.updatedProduct, "kahpoo").subscribe((response) => {
            //console.log("Offre d'emploi modifié avec succès :", response);
            // Réinitialise le formulaire après l'enregistrement réussi
            //this.jobOfferForm.reset();
            //this.showSuccessNotification();
            this.loadProductEmployeJob();
            this.reloadComponent();
            Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Votre offre a été Modifiée avec succès.',
                showConfirmButton: false,
                timer: 1500
            });
        },
        (error) => {
           // console.error("Erreur lors de l'enregistrement de l'offre d'emploi :", error);
            // Gère les erreurs d'enregistrement, par exemple, afficher un message d'erreur à l'utilisateur
            this.showErrorNotification();
        }
    );

  }

  readFile(event: any) {
    if (event.target.files && event.target.files[0]) {
      const file: File = event.target.files[0];
      // console.log("file :"+file);
      const reader = new FileReader();
      reader.onload = (readEvent: any) => {
        // console.log("url"+readEvent.target.result);
        this.photoProduit= readEvent.target.result;
        this.validProductPhoto = this.photoProduit;
        this.whenClickForChangeImage = true;
      };
      reader.readAsDataURL(file);
    }
  }

  // Only AlphaNumeric
  keyPressAlphanumeric(event){
    let inp = String.fromCharCode(event.keyCode);
    if (!/[!@#$%°£§^&*$()_+\=\[\]{};:"\\|<>\/?]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  selectFile00(event: any) {
    var mimeType = event.target.files[0].type;
    var sizeFile=event.target.files[0].size;
    if(!event.target.files[0] || event.target.files[0].length == 0) {
      // this.msg00 = 'Selectionner une photo';
      this.msg00 = '';
    }
    // console.log("size!!!!!")
    // console.log(sizeFile)
    if(sizeFile<2000000){
      // console.log(mimeType);
      if (mimeType=="image/jpeg"||mimeType=="image/jpg"||mimeType=="image/png") {
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msg00 = "";
          this.test00 = true;
          // alert(this.test)
          this.url00 = reader.result;
          this.photoProduit = this.url00;
          // console.log( this.url00);
        }
      }else{

        // this.msg = "Ce type de fichier n'est pas pris en compte.";
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msg00 = "Ce type de fichier n'est pas pris en compte.";
          this.url00 = reader.result;
          this.test00 = false;
        }
      }
    }else{
      // this.msg = "la taille de l'image est trop grande";
      var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msg00 = "La taille de l'image est trop grande";
          this.url00 = reader.result;
          this.photoProduit = this.url00;
          this.test00 = false;
          // console.log( this.url00)
        }
    }
  }

  newpostproduct = new PostSubProducts();
  newPostProd : IPostSubProducts[] =[];
  subProduct = new SubProduct();
  publishProduct(prod:IProduct){
    Swal.fire({
      title: 'Voulez-vous vraiment publier cet offre d\'emploi ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.variantService.subProductById(prod.subProducts[0]?.id).subscribe(data => {
          let newpost= new Post();
          this.subProduct = data;
          this.newpostproduct.subProduct = this.subProduct;
          newpost.title=prod.name;
          newpost.description = "";
          newpost.allowPaymentOnShipping = false;
          this.newpostproduct.allowDelivery = false;
          this.newpostproduct.deliveryDelay="";
          this.newpostproduct.unitDeliveryDuration = "";
          this.newpostproduct.pickFormShop = false;
          newpost.vip=false;
          this.newpostproduct.price = 2000;
          this.newpostproduct.allowPaymentOnShipping = false;

          this.newPostProd.push(this.newpostproduct);
          newpost.postSubProducts = this.newPostProd;

         // console.log("👉️👉️👉️👉️👉️NOUVELLE ANNONCE")
          //console.log(newpost);
          this.postService.savePostBack(newpost).subscribe( rs=>{
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Votre annonce est en attente de validation.',
              showConfirmButton: false,
              timer: 3500
            });
              window.setTimeout(() => {
                window.location.reload()
              }, 1000);
            }, error => {
              Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: error.error.errorMessage,
                showConfirmButton: false,
                timer: 1500
              })
          })
        });
      }

    })

  }

  deleteProduit(prod:IProduct){
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer ce produit ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.productService.deleteProduct_new(prod).subscribe(
          rs=> {

            // console.log("Response de la suppression")
            // console.log(rs)
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Votre produit est supprimé de la liste avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            this.loadProductEmployeJob();
            this.reloadComponent();
          }, error => {
            // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 1500
            })
          }
        )
      }
    })

  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  ascendingOrderByProductName: boolean = true;
  sortByProductName(){
    this.products.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();

      if(this.ascendingOrderByProductName){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByProductName = !this.ascendingOrderByProductName;
  }

  ascendingOrderRef: boolean = true;
  sortByProductReference() {
    this.products.sort((a, b) => {
      const nameA = a.productID;
      const nameB = b.productID;

      if(this.ascendingOrderRef){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderRef = !this.ascendingOrderRef;
  }

  ascendingOrderByCreatedDate: boolean = true;
  sortByCreatedDate() {
    this.products.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      if(this.ascendingOrderByCreatedDate){
        return dateA.getTime() - dateB.getTime();
      }else{
        return dateB.getTime() - dateA.getTime();
      }
    })
    this.ascendingOrderByCreatedDate = !this.ascendingOrderByCreatedDate;
  }

  ascendingCategory: boolean = true;
  sortByCategory() {
    this.products.sort((a, b) => {
      const nameA = a.category.name;
      const nameB = b.category.name;
      if(this.ascendingCategory){
        return nameA.localeCompare(nameA);
      }else{
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderPhoneNumber = !this.ascendingOrderPhoneNumber;
  }

  ascendingOrderByCountryName: boolean = true;
  sortByShopSellerCountryName(){
    this.products.sort((a, b) => {
      const nameA = a.shop.city?.country.iso.toLowerCase();
      const nameB = b.shop.city?.country.iso.toLowerCase();

      if(this.ascendingOrderByCountryName){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByCountryName = !this.ascendingOrderByCountryName;
  }

  ascendingOrderByCityName: boolean = true;
  sortByShopSellerCityName(){
    this.products.sort((a, b) => {
      const nameA = a.shop.city?.name.toLowerCase();
      const nameB = b.shop.city?.name.toLowerCase();

      if(this.ascendingOrderByCountryName){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByCountryName = !this.ascendingOrderByCountryName;
  }

  ascendingOrderPhoneNumber: boolean = true;
  sortByPhoneNumber() {
    this.products.sort((a, b) => {
      const mobileA = a.shop.mobile;
      const mobileB = b.shop.mobile;
      if(this.ascendingOrderPhoneNumber){
        return mobileA.localeCompare(mobileB);
      }else{
        return mobileB.localeCompare(mobileA);
      }
    })
    this.ascendingOrderPhoneNumber = !this.ascendingOrderPhoneNumber;
  }

  ascendingOrderByFirstName: boolean = true;
  sortByShopSellerFirstName(){
    this.products.sort((a, b) => {
      const nameA = a.shop.sellerId?.firstname.toLowerCase();
      const nameB = b.shop.sellerId?.firstname.toLowerCase();

      if(this.ascendingOrderByFirstName){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByFirstName = !this.ascendingOrderByFirstName;
  }

  exportPostToExelFile(filename: string) {
    const data = document.getElementById('tab-post');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(data);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, filename);
  }

  beginDateVal: any = null;
  displayErrorMessage: boolean = false;
  getBeginDate(event: any) {
    this.beginDateVal = event.target.value;
    if(this.beginDateVal != null){
      this.disableEndDate = false;
      if(this.beginDateVal > this.endDateVal){
        this.displayErrorMessage = true;
      }else {
        this.displayErrorMessage = false;
      }
    }
  }

  endDateVal: any = null;
  disableEndDate: boolean = true;
  getEndDate(event: any) {
    this.endDateVal = event.target.value;
    //console.log(this.endDateVal);
    if(this.beginDateVal > this.endDateVal){
      this.displayErrorMessage = true;
    }else{
      this.displayErrorMessage = false;
    }
  }

  refresh() {
    this.loadProductEmployeJob();
    this.dateForm.patchValue({
      beginDate: '',
      endDate: ''
    })
  }

  beginDate: any = "";
  endDate: any = "";
  filterByDate() {
    if(this.dateForm.get('beginDate').value=='' || this.dateForm.get('endDate').value=='') {
      //console.log("Date sélectionnée")
      //console.log('beginDate:', this.beginDate);
      //console.log('endDate:', this.endDate);
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      });
      return;
    }else{
      this.beginDate = new Date(this.dateForm.get('beginDate').value).toISOString();
      this.endDate = new Date(this.dateForm.get('endDate').value).toISOString();
      this.productService.getProductEmployeJobByDate_v1(this.beginDate, this.endDate,this.pageNumber - 1, this.pageSize).subscribe(data =>{
        this.products = data.content;
        this.totalItems = data.totalElements;

        //console.log("Liste des produits....");
        //console.log(this.products)
      });
    }
  }

  searchProducts($event: KeyboardEvent) {
    this.products = this.productsTmp.filter(value =>
      value?.name.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.productID.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.category?.name?.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.shop?.city?.name.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.shop?.city?.country?.iso.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.shop?.sellerId?.firstname.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.shop?.sellerId?.lastname.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.shop?.address.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      (Number(this.search) === Number(value?.shop?.mobile))
    )
  }

  // Profil recherché
  getProfilName(p): string | undefined {
      const name = "required.profile";
      if (p.subProducts[0] && p.subProducts[0].subProductCharacteristics) {
          const characteristic = p.subProducts[0].subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
          return characteristic ? characteristic.value : undefined;
      }
      return undefined;
  }

  // Type du contrat
  getTypeContrat(p): string | undefined {
    let name = "type.of.contract";
    if(p.subProducts[0] && p.subProducts[0].subProductCharacteristics){
      const characteristic = p.subProducts[0].subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  // Pays
  getPays(p): string | undefined {
    let name = "contract.country";
    if(p.subProducts[0] && p.subProducts[0].subProductCharacteristics){
      const characteristic = p.subProducts[0].subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  // Ville
  getVille(p): string | undefined {
    let name = "contract.city";
    if(p.subProducts[0] && p.subProducts[0].subProductCharacteristics){
      const characteristic = p.subProducts[0].subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  // Numéro de téléphone
  getPhoneNumber(p): string | undefined {
    let name = "phone.number";
    if(p.subProducts[0] && p.subProducts[0].subProductCharacteristics){
      const characteristic = p.subProducts[0].subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  getIndicatif(p): string | undefined {
    let name = "code.country";
    if(p.subProducts[0] && p.subProducts[0].subProductCharacteristics){
      const characteristic = p.subProducts[0].subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  // E- mail
  getEmail(p): string | undefined {
    let name = "email.contact";
    if(p.subProducts[0] && p.subProducts[0].subProductCharacteristics){
      const characteristic = p.subProducts[0].subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  // Date limite de l’offre
  getLimitDate(p): string | undefined {
    let name = "offer.deadline";
    if(p.subProducts[0] && p.subProducts[0].subProductCharacteristics){
      const characteristic = p.subProducts[0].subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  // Présentation de l'entreprise
  entreprisePresentation(p): string | undefined {
    let name = "company.presentation";
    if(p.subProducts[0] && p.subProducts[0].subProductCharacteristics){
      const characteristic = p.subProducts[0].subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  //Description de l'offre
  offerDescription(p): string | undefined {
    let name = "description.of.the.offer";
    if(p.subProducts[0] && p.subProducts[0].subProductCharacteristics){
      const characteristic = p.subProducts[0].subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  jobApplyid ?: number;
  jobApplyname ?: string;
  shareJobApply(jobApply : any){
    this.jobApplyid = jobApply?.id;
    this.jobApplyname = jobApply?.name;
    if(this.jobApplyid != undefined && this.jobApplyname != undefined){
      const data  = undefined ? '' : JSON.stringify(this.jobApplyid);
      const data1  = undefined ? '' : JSON.stringify(this.jobApplyname);
      const datacryt = this.encryptionService.encryptionAES(data);
      const datacryt1 = this.encryptionService.encryptionAES(data1);
      window.localStorage.setItem('khshshopid!#',datacryt);
      window.localStorage.setItem('khshshopname!#',datacryt1);
      this.sharedSevice.jobApplyidshared = this.jobApplyid;
      this.sharedSevice.jobApplynameshared = this.jobApplyname;
    }
  }

  offerDetailsDisplayed :any;
  offerDetails(offer : any){
    this.offerDetailsDisplayed = offer;
  //   console.log("Détail de l'offre ....");
  //  console.log(this.offerDetailsDisplayed);
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

}
